import React, { useMemo } from 'react';
import appStore from '../app';

const themedComponent = config => props => {
  const { store } = appStore;
  const {
    webmaster: { profile },
  } = store.getState();
  const { theme } = profile;

  const ThemedComponent = useMemo(() => (config[theme] ? config[theme] : config['default']), []);

  return <ThemedComponent {...props} />;
};

export default themedComponent;
